export default {
    "Success": true,
    "htmlMessage": null,
    "Data": {
        "count": 3,
        "value": [
            {
                "id": "0b11a307-1682-427d-9db2-726033357174",
                "name": "Second Project",
                "url": "https://dev.azure.com/devopsintegrationio/_apis/projects/0b11a307-1682-427d-9db2-726033357174",
                "state": "wellFormed",
                "revision": 20,
                "visibility": "private",
                "lastUpdateTime": "2021-03-04T08:04:49.997Z"
            },
            {
                "id": "9ee885ad-3670-4f11-ae60-01d415a5af12",
                "name": "First Project",
                "url": "https://dev.azure.com/devopsintegrationio/_apis/projects/9ee885ad-3670-4f11-ae60-01d415a5af12",
                "state": "wellFormed",
                "revision": 12,
                "visibility": "private",
                "lastUpdateTime": "2021-02-23T07:09:44.967Z"
            },
            {
                "id": "19720a67-640b-4be6-a041-4f05a404ac66",
                "name": "Third Project",
                "url": "https://dev.azure.com/devopsintegrationio/_apis/projects/19720a67-640b-4be6-a041-4f05a404ac66",
                "state": "wellFormed",
                "revision": 28,
                "visibility": "private",
                "lastUpdateTime": "2021-04-18T05:54:24.217Z"
            }
        ]
    }
}